export default "__VITE_ASSET__5915ec70__"